import { RegistryBase } from 'packages/core'

/**
 * Contains all instances registered in the system. Instances
 * are separated out in different namespaces for better organization.
 */
export class Registry extends RegistryBase {}
